export default __webpack_public_path__ + "static/media/driver-icon.4e0161fb.svg";